import styled from "styled-components";
import { Button } from "ui";

export const Label = styled.label`
  height: 36px;
  width: 100%;
  max-width: 330px;

  display: flex;
  align-items: center;
  gap: 15px;

  background-color: ${({ theme }) => theme.old.colors.blue[900]};
  border-radius: 6px;
  padding-left: 12px;

  border: 1.5px solid ${({ theme, $isFocus }) => $isFocus
    ? theme.old.colors.primary
    : theme.old.colors.transparent
  };
`

export const IconWrapper = styled.div`
  color: ${({ theme, $isFocus }) => $isFocus
    ? theme.old.colors.primary
    : theme.old.colors.gray[625]
  };
`

export const InputStyled = styled.input`
  height: 100%;
  width: 100%;
  border: none;

  background-color: transparent;
  color: ${({ theme }) => theme.old.colors.gray[100]};
  caret-color: ${({ theme }) => theme.old.colors.primary};
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};

  ::placeholder {
    color: ${({ theme }) => theme.old.colors.gray[625]}
  }
`

export const ClearBtn = styled(Button)`
  /* color: ${({ theme }) => theme.old.colors.gray[550]}; */
  color: #AFAFAF;
  border: none;
  :active {
    color: #AFAFAF;
    /* color: ${({ theme }) => theme.old.colors.gray[550]}; */
  }
  :hover {
    color: #AFAFAF;
    /* color: ${({ theme }) => theme.old.colors.gray[550]}; */
  }
`